import type { CSSProperties } from "react";

/** URL фонового изображения секции (S3 / CDN). Пустая строка = без картинки. */
export type LandingBackgroundImageUrl = string;

export function normalizeBackgroundImageUrl(
  value: unknown,
): LandingBackgroundImageUrl {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!trimmed) return "";
  if (trimmed.startsWith("https://") || trimmed.startsWith("http://")) {
    return trimmed;
  }
  return "";
}

export function landingSectionBackgroundStyle(
  imageUrl: LandingBackgroundImageUrl,
  options?: { overlay?: boolean },
): CSSProperties | undefined {
  if (!imageUrl) return undefined;
  const overlay = options?.overlay !== false;
  return {
    backgroundImage: overlay
      ? `linear-gradient(color-mix(in srgb, var(--color-background-body) 72%, transparent), color-mix(in srgb, var(--color-background-body) 88%, transparent)), url("${imageUrl}")`
      : `url("${imageUrl}")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };
}
